import {Pipe, PipeTransform} from '@angular/core';
import {FOLDER_STATES} from "../../../../views/pages/apps/Shared/Constants/folderStates";

@Pipe({
    name: 'translateOrderState',
})
export class TranslateFolderOrderStatePipe implements PipeTransform {
    transform(State: string): string {
        const val = FOLDER_STATES.find(item => item.value === State);
        if (val) {
            return val.order + '. ' + val.name;
        } else {
            switch (State) {
                case 'EK_ORDER_CREATED':
                    return 'Commande créée';

                case 'EK_ORDER_PENDING':
                    return 'Commande en attente';

                case 'EK_ORDER_IN_PREPARATION':
                    return 'Commande en préparation';

                case 'DELIVERED_POS':
                    return 'Pos livré';

                case 'EK_ORDER_IN_DELIVERY':
                    return 'Livraison en cours';

                case 'EK_ORDER_DELIVERED':
                    return 'Client livré';

                case 'EK_CLIENT_ORDER_CANCELED':
                    return 'Commande annulée';

                default:
                    return State;
            }
        }
    }
}
